import * as Actions from '../actions/modernDashboard.actions';

const initialState = {
	dashboardType: 'modern', // 'modern' | 'legacy'
	themeMode: 'dark', // 'dark' | 'light'
	pinnedApplications: [],
	lastUpdated: null,
	loading: false,
	error: null
};

const userPreferencesReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.GET_USER_PREFERENCES_REQUEST:
		case Actions.UPDATE_USER_PREFERENCES_REQUEST:
		case Actions.PIN_APPLICATION_REQUEST:
		case Actions.UNPIN_APPLICATION_REQUEST:
			return {
				...state,
				loading: true,
				error: null
			};

		case Actions.GET_USER_PREFERENCES_SUCCESS:
			return {
				...state,
				dashboardType: action.payload.dashboardType,
				themeMode: action.payload.themeMode,
				pinnedApplications: action.payload.pinnedApplications,
				lastUpdated: action.payload.lastUpdated,
				loading: false,
				error: null
			};

		case Actions.UPDATE_USER_PREFERENCES_SUCCESS:
		case Actions.PIN_APPLICATION_SUCCESS:
		case Actions.UNPIN_APPLICATION_SUCCESS:
			return {
				...state,
				dashboardType: action.payload.dashboardType,
				themeMode: action.payload.themeMode,
				pinnedApplications: action.payload.pinnedApplications,
				lastUpdated: action.payload.lastUpdated,
				loading: false,
				error: null
			};

		case Actions.GET_USER_PREFERENCES_FAILURE:
		case Actions.UPDATE_USER_PREFERENCES_FAILURE:
		case Actions.PIN_APPLICATION_FAILURE:
		case Actions.UNPIN_APPLICATION_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload
			};

		default:
			return state;
	}
};

export default userPreferencesReducer;
